import React, { useState, useRef } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import moment from 'moment'
import gql from 'graphql-tag'
import { useTranslation } from 'react-i18next'

import getNameOfGqlQuery from 'helpers/getNameOfGqlQuery'
import ContentBlock from 'components/ContentBlock'
import { Form, Select, DateTimePicker, Checkbox } from 'components/forms'
import Button from 'components/Button'
import Divider from 'components/Divider'
import { useMutation } from 'components/graphql'

import mutation from '../../gql/exportBills'

const queryCrs = gql`
	query listCashRegisters {
		cashAssist {
			listCashRegisters(activeOnly: true, params: {
				sort: [{ field: "name", order: ASC }]
			}) {
				id
				name
			}
		}
	}
`

const Csb = () => {
	const [t] = useTranslation()
	const formApi = useRef()
	const [saveFile, setSaveFile] = useState(false)

	const initialValues = { date: moment().utc().startOf('day').toISOString() }

	const [mutate, { loading: isSubmitting }] = useMutation(mutation, {
		onCompleted: data => {
			formApi.current.reset()
			if (saveFile) {
				const mutationName = getNameOfGqlQuery(mutation)
				const s3Key = data?.[mutationName]?.key
				if (s3Key) {
					const bucket = import.meta.env.VITE_STAGE === 'prod'
						? 'hscustomer.s3-eu-west-1.amazonaws.com'
						: 'cashassist-api-dev-uploads.s3-eu-west-1.amazonaws.com'
					window.open(`https://${bucket}/${s3Key}`, '_blank')
				} else {
					throw new Error('S3 Upload error.')
				}
			}
		},
		onError: e => {
			throw new Error(e)
		}
	})

	const handleSubmit = vals => {
		const mutateVals = { ...vals }
		if (vals.cashRegisterId === 'null') {
			mutateVals.cashRegisterId = null
		}
		mutate({ variables: mutateVals })
	}

	return (
		<ContentBlock label='CSB'>
			<Form initialValues={initialValues} onSubmit={handleSubmit} getApi={api => (formApi.current = api)}>
				<Row>
					<Col xs>
						<Select
							field='cashRegisterId'
							label={t('common.fields.cash_register')}
							remoteOptions={{
								query: queryCrs,
								additionalOptions: [{ id: 'null', name: t('statistic_section.strings.all_cash_registers') }]
							}}
							valueField='id'
							labelField='name'
							isSearchable
							validate={val => val ? null : t('validators.required')}
							validateOnChange
						/>
						<Select
							field='type'
							label={t('common.fields.type')}
							options={[
								{ value: 'closing', label: 'LABO_UM' },
								{ value: 'userTime', label: 'BED_ZEIT' }
							]}
							validate={val => val ? null : t('validators.required')}
							validateOnChange
						/>
						<Checkbox
							field='isTemporary'
							label={t('options_section.fields.download_file')}
							checked={saveFile}
							onChange={e => setSaveFile(e.target.checked)}
						/>
					</Col>
					<Col xs>
						<DateTimePicker
							field='date'
							label={t('common.fields.date')}
							validate={val => val ? null : t('validators.required')}
							validateOnChange
						/>
					</Col>
				</Row>
				<Divider />
				<Button
					type='submit'
					text={t('common.buttons.apply')}
					loading={isSubmitting}
				/>
			</Form>
		</ContentBlock>
	)
}

export default Csb
